import { t } from '@lingui/core/macro';

export type AggregationNameResolver = (aggregation: string) => string | undefined;

export function defaultAggregationNameResolver(aggregation: string): string | undefined {
  const map: Record<string, string> = {
    percentile: t`Percentile`,
    mean: t`Average`,
    median: t`Median`,
    max: t`Maximum`,
    min: t`Minimum`,
    sum: t`Sum`,
  };
  return map[aggregation] ?? undefined;
}
